(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    

    function getCart() {
      fetch('/cart.js', {
          method: 'GET',
          headers: {
              'Accept': 'application/json'
          }
      })
      .then(response => response.json())
      .then(data => {
          console.log('Cart data before:', data);
          const items = data['items']
          for (i in items) {
              var item = items[i];
              console.log(JSON.stringify(item));
              if (item['selling_plan_allocation']) {
                  console.log('Cart contains a subscription');
                  document.getElementById("subscriptionInput").value = "true";
              }
              else {
                  console.log('Cart does not contain a subscription');
                  document.getElementById("subscriptionInput").value = "false";
              }
          }
          console.log('Cart data after:', data);
      })
      .catch(error => {
          console.error('Error clearing cart:', error);
      });
    }

    window.onload = function() {
      document.getElementById('cart').addEventListener('submit', function() {
        document.getElementById('overlay').style.display = 'block';
      });
    };
    
    window.onpageshow = function() {
      document.getElementById('overlay').style.display = 'none';
      
      document.getElementById("vinInput").value = sessionStorage.getItem("vin");
      document.getElementById("shoppingTokenInput").value = sessionStorage.getItem("shoppingToken");
      getCart();
    };
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  document.cookie = "localization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  document.cookie = "cart_currency=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  const urlParams = new URLSearchParams(window.location.search);
  const shoppingToken = urlParams.get('shoppingToken');

  if(shoppingToken != null){
    sessionStorage.setItem("shoppingToken", shoppingToken);
  }
  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  function clearDiscount() {
    fetch('/discount/CLEAR');
  }

  function clearCart() {
      fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
          }
      })
      .then(response => response.json())
      .then(data => {
          console.log('Cart cleared:', data);
          clearDiscount();
      })
      .catch(error => {
          console.error('Error clearing cart:', error);
      });
  }

  function filterProductIds() {
    const shoppingToken = sessionStorage.getItem("shoppingToken");
    fetch('https://kcs.karmaautomotive.com/shopping/product/ids?shoppingToken=' + shoppingToken).then(function(response) {
      return response.json();
    }).then(function(data) {
      sessionStorage.setItem("product_ids", JSON.stringify(data));

      const products = JSON.parse(JSON.stringify(data));
      products.forEach(function(product, index){
          var link = document.getElementById(product.productId);
          if(link != null){           
            link.style.display = 'inline';
          }
          else{
            link.style.display = 'none';
          }
          
      });

    }).catch(function(err) {
      console.log('Fetch Error :-S', err);
    });
  }

  window.onpageshow = function() {
    filterProductIds();
    clearCart();
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
      function clearCart() {
          fetch('/cart/clear.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
              }
          })
          .then(response => response.json())
          .then(data => {
              console.log('Cart cleared:', data);
              clearDiscount();
          })
          .catch(error => {
              console.error('Error clearing cart:', error);
          });
      }

      function clearDiscount() {
        fetch('/discount/CLEAR');
      }

      window.onpageshow = function() {
        clearCart();
      };
      
    
  } catch(e) { console.error(e); }
})();
})();
